import { Box, Grid, Paper, Typography, CircularProgress, TextField, MenuItem, Checkbox, Pagination, InputAdornment } from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { Link } from 'react-router-dom';

const EmptyData = () => {
    return (
        <>
            <Paper className="p-4" style={{ marginTop: "1rem" }}>
                <Grid container justifyContent="space-between" style={{ paddingBottom: "14px" }}>
                    <Typography fontSize="28px" fontFamily={"karla"}>Payroll Record</Typography>
                    <Link to="/firehouse/manage-payroll">
                        <ButtonTheme variant="filled" color='blue' style={{ height: 40 }}>
                            Manage Payroll Config
                        </ButtonTheme>
                    </Link>
                </Grid>
                <Typography fontSize="20px" fontFamily={"karla"} color="#555555">There are no Payroll available, please add them as needed.</Typography>
                <Grid container gap="24px" justifyContent="center" alignItems="center" flexDirection="column" style={{ padding: "36px 0 22px", border: "1px solid #EAECF0", borderRadius: "8px", marginTop: "12px" }} >
                    <img src='/images/blur-logo.png' style={{ width: 200, height: 'auto' }} />
                    <Link to="/firehouse/add-payroll">
                        <ButtonTheme variant="filled" color='primary' style={{ height: 40 }}>
                            Add New
                        </ButtonTheme>
                    </Link>
                </ Grid>
            </Paper >
        </>
    )
}

export default EmptyData;